import styled, { css } from 'styled-components';
import { darkModeBackground } from 'global/colors';

export const FreecodePageBackground = styled.div`
  height: 100%;
  width: 100%;
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      background-color: ${darkModeBackground};
    `}
`;

export const FreecodePageContentContainer = styled.div`
  padding-top: 55px;
  height: 100%;
  width: 100%;
`;
